import React from 'react'
import { Routes, Route, useNavigate, useLocation, Navigate } from 'react-router-dom'
import Router from './Components/Router'
import './App.css'


import { DataProvider } from './Context/LocDataContext';
import MainStatsPage from './Pages/User/DashBoard/MainStats';
import SceneStats from './Pages/User/DashBoard/SceneStats';

function App() {
  // return (
  //   <div className="App">
  //     <Router />
  //   </div>
  // )
  return (
    <DataProvider>
      <Router/>
    </DataProvider>
  );
}

export default App
